// extracted by mini-css-extract-plugin
module.exports = {"badgeContainer":"Badge_badgeContainer__Ze1HT","badgeBorder":"Badge_badgeBorder__xekyu","badge":"Badge_badge__Hup7y"};